module.exports = __webpack_public_path__ + "media/images/img-travel-2-1cd6f33c.jpg";